import { BreakpointObserver } from '@angular/cdk/layout';
import {
    computed,
    inject,
    Injectable,
    signal,
    type Signal,
} from '@angular/core';

/** Viewport widths in CSS pixels. Each boundary divides < width from >= width. */
export const MAJOR_VIEWPORT_BREAKPOINTS = {
    tablet: 640,
    laptop: 1024,
} as const;

export const MINOR_VIEWPORT_BREAKPOINTS = {
    phone480: 480,
    tablet768: 768,
    desktop: 1280,
    desktop1536: 1536,
} as const;

@Injectable({ providedIn: 'root' })
export class DeviceDetectorService {
    private readonly breakpointObserver = inject(BreakpointObserver);
    private readonly atLeastCache = new Map<number, Signal<boolean>>();
    private readonly lessThanCache = new Map<number, Signal<boolean>>();

    atLeast(width: number): Signal<boolean> {
        const cached = this.atLeastCache.get(width);
        if (cached) return cached;

        const query = `(min-width: ${width}px)`;
        const matches = signal(this.breakpointObserver.isMatched(query));
        this.breakpointObserver
            .observe(query)
            .subscribe(({ matches: current }) => matches.set(current));

        const result = matches.asReadonly();
        this.atLeastCache.set(width, result);
        return result;
    }

    lessThan(width: number): Signal<boolean> {
        const cached = this.lessThanCache.get(width);
        if (cached) return cached;

        const atLeast = this.atLeast(width);
        const result = computed(() => !atLeast());
        this.lessThanCache.set(width, result);
        return result;
    }
}
